// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"5d5bc688","984":"b04a52c0"}[chunkId] + ".chunk.css";
};